import React from 'react'
import { WithTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { Form, FormGroup, NumberInput, Select, TextInput } from '../../../components/FormBuilder'
import DateRangeContainerWithDateFields
  from '../../../components/FormBuilder/DateRangeInput/DateRangeContainerWithDateFields'
import { is } from '../../../components/MediaQuery'
import { IWithSize } from '../../BookingCalendar/Calendar/Calendar'
import { IFilterRoomsValues } from './withReduxForm'

type IFilterRooms = WithTranslation & IFilterRoomsDates & IFilterRoomsProps

function FilterRooms({
                       t,
                       daysCount,
                       initialValues,
                       size = 1,
                     }: IFilterRooms & IWithSize) {
  const isDesktop = is.desktop()

  return (
    <Form onSubmit={null}>
      <Flex style={{ height: '100%', padding: `${size}em` }} column={true}>
        <FormGroup.Render size={size} title={t('z677_term')} column={true}>
          <FormGroup.Nested size={size} row={true}>
            <Flex style={{ width: '95%' }} alignStart={true}>
              <DateRangeContainerWithDateFields>
                {({ DateFromInput, DateToInput }) => (
                  <>
                    <DateFromInput
                      size={size}
                      label={t('reservation_from')}
                      name={'dateFrom'}
                      sizedOnMobile={true}
                      withEmptyOnStart={true}
                      offsetLeft={isDesktop ? 30 : 0}
                      disableMobileResizing={true}
                      wrapperStyle={{ marginRight: `${5 * size}px` }}
                      startDate={initialValues.dateFrom}
                    />
                    <DateToInput
                      size={size}
                      label={t('reservation_to')}
                      name={'dateTo'}
                      withEmptyOnStart={true}
                      sizedOnMobile={true}
                      offsetLeft={-20}
                      disableMobileResizing={true}
                      wrapperStyle={{ marginLeft: `${5 * size}px` }}
                      startDate={initialValues.dateTo}
                    />
                  </>
                )}
              </DateRangeContainerWithDateFields>
            </Flex>
          </FormGroup.Nested>
          <NumberInput.ReduxField
            size={size}
            label={t('z677_number_of_nights')}
            name={'daysCount'}
            width={isDesktop ? `120px` : '100%'}
            style={isDesktop ? {} : { width: '100%' }}
            minValueForNumber={0}
            maxValueForNumber={365}
            value={daysCount}
          />
        </FormGroup.Render>
        <FormGroup.Render size={size} title={t('accommodation')} column={true}>
          <Select.ReduxField
            size={size}
            label={t('number_of_people')}
            name={'numPersons'}
            width={'100%'}
            placeholder={t('select')}
            staticMenu={true}
          >
            {[...new Array(21)].map((num, index) => (
              <Select.Option key={index} value={index}>
                {index === 0 ? t('select') : index}
              </Select.Option>
            ))}
          </Select.ReduxField>
          <TextInput.ReduxField
            size={size}
            label={t('object_type')}
            name={'name'}
            width={'100%'}
          />
        </FormGroup.Render>
      </Flex>
    </Form>
  )
}

export default FilterRooms

export interface IFilterRoomsDates {
  dateTo?: Date
  daysCount?: number
}

export interface IFilterRoomsProps {
  initialValues: IFilterRoomsValues
}
